export default __webpack_public_path__ + "static/media/customer-banner.47512ef8.jpg";